/** @format */
import { AxiosInstance } from 'axios';

import { changeCaseInterceptor } from './interceptors/change-case';
import { validationMessagesInterceptor } from './interceptors/validation';

export function addInterceptors(client: AxiosInstance) {
    // Rename object keys to and from the API so we can model our data in camelCase
    // But send and receive in snake_case for the pythons.
    client.interceptors.request.use(
        changeCaseInterceptor.requestFulfilled,
        undefined
    );
    client.interceptors.response.use(
        changeCaseInterceptor.responseFulfilled,
        changeCaseInterceptor.responseRejected
    );

    // Move validation messages to the top level of the error
    client.interceptors.response.use(
        undefined,
        validationMessagesInterceptor.responseRejected
    );
}
